export default __webpack_public_path__ + "static/marketplace-fraud-img-2-5d79b5990574fbb1600b22a852cd092f.svg";